import { apiFactory } from "../api_factory";

export const userAlertsApi = apiFactory({
  path: "/api/v4/alerts-engine/user-alerts",
  urlExtension: "resolve"
});
